import { render, staticRenderFns } from "./DriversTab.vue?vue&type=template&id=c833fa94"
import script from "./DriversTab.vue?vue&type=script&lang=js"
export * from "./DriversTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports